export type {
  AvatarNamedColor,
  AvatarBaseProps,
  AvatarProps,
  AvatarShape,
  AvatarSize,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  AvatarSizes,
  AvatarBaseSlots,
  AvatarSlots,
  AvatarBaseState,
  AvatarState,
} from './Avatar.types';
export { Avatar } from './Avatar';
export { renderAvatar_unstable } from './renderAvatar';
export { DEFAULT_STRINGS, useAvatar_unstable, useAvatarBase_unstable } from './useAvatar';
export { avatarClassNames, useAvatarStyles_unstable, useSizeStyles } from './useAvatarStyles.styles';
